import React from 'react';
import { Link } from 'react-router-dom';
import '../components/landing/landing.css';
import { LandingNavbar } from '../components/landing/LandingNavbar';
import { PricingHero } from '../components/landing/pricing/PricingHero';
import { PricingGrid } from '../components/landing/pricing/PricingGrid';
import { ValueCalculator } from '../components/landing/pricing/ValueCalculator';
import { PricingFAQ } from '../components/landing/pricing/PricingFAQ';
import { LandingFooter } from '../components/landing/LandingFooter';

export default function PricingPage() {
  return (
    <div data-testid="pricing-page" className="sera-landing">
      <LandingNavbar />
      <PricingHero />
      <PricingGrid />

      <div className="text-center px-6 pb-6">
        <p className="text-zinc-500 text-sm" data-testid="pricing-onboarding-note">
          ¿Necesitas ayuda para arrancar? Ofrecemos un servicio de onboarding personalizado por 99€ (pago único).
        </p>
      </div>

      <ValueCalculator />
      <PricingFAQ />

      <section className="py-16 text-center px-6">
        <h2 className="text-2xl md:text-3xl font-black tracking-tighter text-white mb-5">
          ¿Aún no sabes qué plan elegir?
        </h2>
        <Link
          to="/#demo"
          data-testid="pricing-final-cta"
          className="sera-glow-cta inline-flex items-center gap-2 rounded-full bg-[#00E5FF] text-black font-semibold px-8 py-3.5"
        >
          Solicita una demo
        </Link>
      </section>

      <LandingFooter />
    </div>
  );
}
